// extracted by mini-css-extract-plugin
module.exports = {"navigationButton":"_2dOBCHC2","navigationButtonText":"_1WsyIF91","navigationFilesSizeProgress":"_1ND8Gvtu"};